import React, { useCallback, useContext, useEffect, useState } from "react";
import { RoomsRealtimeContext } from "@common/components/ListDetailViews/Layout/context";
import {
  NotificationContext,
  useErrorNotification,
} from "@common/components/Notification";
import { getMeetingDialInfo } from "@services/meetings";
import Button from "@common/components/Button";
import { useTranslation } from "react-i18next";

const DialinButton = () => {
  const context = useContext(RoomsRealtimeContext);
  const meeting = { ...context.detail?.meeting };
  const dispatchError = useErrorNotification();
  const { dispatchNotification } = useContext(NotificationContext);
  const { t } = useTranslation();

  const [dialinfo, setDialinfo] = useState<string>();

  const fetch = async (id: typeof meeting.id) => {
    try {
      setDialinfo((await getMeetingDialInfo(meeting.id, true)).dialInfo);
    } catch (e) {
      dispatchError(e);
    }
  };

  useEffect(() => {
    if (meeting?.id !== undefined) fetch(meeting.id);
  }, [context.detail?.meeting?.id]);

  const handleClick = useCallback(async () => {
    // should never happened, as the button is disabled
    if (dialinfo === undefined) return;
    try {
      await navigator.clipboard.writeText(dialinfo);
      dispatchNotification({
        title: t("Success"),
        severity: "success",
        message: t("Successfully copied dial-in information to the clipboard"),
      });
    } catch (e) {}
  }, [dialinfo]);

  return (
    <Button
      color="white"
      sx={{ marginTop: 2 }}
      loading={dialinfo === undefined}
      onClick={() => handleClick()}
    >
      Copy to clipboard
    </Button>
  );
};
export default DialinButton;
